import { ServicePricing } from '@/components/services/ServicePricing'
import { serviceOffers } from '@/data/pricing'

export const BioScanPricing = () => (
  <ServicePricing
    title="Explore your"
    accent="scan options"
    description="Not sure which assessment to choose? Kandake can talk you through the options before you book."
    offers={[serviceOffers.holisticScan, serviceOffers.bioScan]}
  />
)
